import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, Clock, Compass } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: <HelpCircle size={28} data-id="element-105" />,
    title: 'No sabes qué tratamiento necesitas',
    description: 'Es normal sentir confusión ante un problema dental. Te ayudamos a entender exactamente qué ocurre.'
  }, {
    icon: <Clock size={28} data-id="element-106" />,
    title: 'Te preocupa perder tiempo en vueltas innecesarias',
    description: 'Valoramos tu tiempo. Nos enfocamos en diagnósticos precisos y pasos concretos.'
  }, {
    icon: <Compass size={28} data-id="element-107" />,
    title: 'Quieres una orientación clara antes de decidir',
    description: 'Te explicamos todas tus opciones con transparencia para que tomes la mejor decisión.'
  }];
  return <section className="bg-white py-20 lg:py-28" data-id="element-108">
      <div className="container mx-auto px-4 md:px-6" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mx-auto max-w-3xl text-center" data-id="element-110">
          <h2 className="mb-6 text-3xl font-bold tracking-tight text-brand-dark sm:text-4xl" data-id="element-111">
            Cuando tienes un problema dental, necesitas claridad
          </h2>
          <p className="mb-12 text-lg text-slate-600" data-id="element-112">
            Muchas personas postergan su atención dental porque no saben qué
            tratamiento necesitan, cuánto puede costar o si realmente les
            explicarán una solución concreta. Una buena atención parte por
            escuchar, revisar y orientar con claridad.
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-3" data-id="element-113">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="rounded-2xl border border-slate-100 bg-slate-50 p-8 text-center transition-shadow hover:shadow-md" data-id="element-114">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-white text-brand-dark shadow-sm" data-id="element-115">
                {problem.icon}
              </div>
              <h3 className="mb-3 text-xl font-semibold text-brand-dark" data-id="element-116">
                {problem.title}
              </h3>
              <p className="text-slate-600" data-id="element-117">{problem.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}